import { onMounted } from 'vue';
import { defineRawAsyncComponent } from '~/utils/defineRawAsyncComponent';
import { preFetchAsyncComponents } from '~/utils/preFetchAsyncComponents';

import useExperiments from '~/stores/useExperimentsStore';

export default function useExperimentedAvailabilityComps() {
  const { experimentFlags: { isBigTicketDeliveryMethodsEnabledExp = false } = {} } = useExperiments();

  const notAvailableCompLoader = () =>
    isBigTicketDeliveryMethodsEnabledExp
      ? import('~/modules/availability/components/experiments/NotAvailable.vue')
      : import('~/modules/availability/components/NotAvailable.vue');
  const shipToZipCodeCompLoader = () =>
    isBigTicketDeliveryMethodsEnabledExp
      ? import('~/modules/availability/components/experiments/ShipToZipCode.vue')
      : import('~/modules/availability/components/ShipToZipCode.vue');
  const noZipCodeCompLoader = () =>
    isBigTicketDeliveryMethodsEnabledExp
      ? import('~/modules/availability/components/experiments/NoZipCode.vue')
      : import('~/modules/availability/components/NoZipCode.vue');
  const unavailableDeliveryMessageCompLoader = () => import('~/modules/availability/components/experiments/UnavailableDeliveryMessage.vue');

  const NotAvailable = defineRawAsyncComponent(notAvailableCompLoader);
  const ShipToZipCode = defineRawAsyncComponent(shipToZipCodeCompLoader);
  const NoZipCode = defineRawAsyncComponent(noZipCodeCompLoader);
  const UnavailableDeliveryMessage = isBigTicketDeliveryMethodsEnabledExp ? defineRawAsyncComponent(unavailableDeliveryMessageCompLoader) : null;

  onMounted(() => {
    preFetchAsyncComponents(NotAvailable);
    preFetchAsyncComponents(ShipToZipCode);
    preFetchAsyncComponents(NoZipCode);
    if (UnavailableDeliveryMessage) {
      preFetchAsyncComponents(UnavailableDeliveryMessage);
    }
  });

  return {
    NotAvailable,
    ShipToZipCode,
    NoZipCode,
    UnavailableDeliveryMessage,
  };
}
